<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">Documento de la Unidad de Inspección</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header">
                    </div>
                    <div class="card-body-detalle">
                        <!--Documento-->
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpDescripcion">Descripción Documento</label>
                                <textarea style="resize:none" formControlName="Descripcion" [ngClass]="displayFieldCss('Descripcion')"
                                          maxlength="5000" name="Descripcion" title="" type="text" class="form-control" inputStyleClass="form-control"
                                          value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Descripción Documento es obligatoria
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="readonly"
                                                       [required]="true" [documentModule]="documentModuleCampania"
                                                       [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit"
                                                       (fileUploaded)="onFileUploaded($event)" (fileDeleted)="onFileDeleted($event)">
                                </app-document-uploader>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    </form>
</div>

